export default __webpack_public_path__ + "static/digital_print4-3bad917f897c46e43708e8cf72d8ec1d.jpg";